var util = require('../../util');
'use strict';

/**
 * Module is used for showing tooltips
 */

// const is not used because of Safari compatibility
var jsTooltipClass = 'js-tooltip';

exports.show = function ($container, text, extraOffset = 0,isScroll=true) {
	$('.' + jsTooltipClass).remove();
	
	var $jsTooltip = $container.parent().find('.' + jsTooltipClass),
		navOffset = 0, checkViewPort = true;
     
	if (util.isMobile()) {
		navOffset = $('.header__main').height();
	}

	if (!$jsTooltip.length) {
		$container.before(
			$('<div/>').addClass(jsTooltipClass)
				.html(text)
		);
	}

    $jsTooltip.show();
    
    var $topContainer = $container.parent().find('.' + jsTooltipClass);
    if (!util.isMobile()) {
         var $pdpContainer = $container.closest('#pdpMain');
         if ($pdpContainer && $pdpContainer.length > 0) {
             if (!$pdpContainer.hasClass("quickview__dialog")) {
                 checkViewPort = false;
                 navOffset = 50;
                 $topContainer = $pdpContainer;
             }
         }
	} 
    
	if (!util.isMobile() && checkViewPort && $topContainer.isInViewport()) {
		return;
	}

	if ($('body').hasClass('overlay--shown')) {
		return;
	}
	
	if(isScroll) {
		$('html, body').animate({
			scrollTop: $topContainer.offset().top - navOffset - extraOffset
		}, 500);
	}
}

exports.hide = function ($container) {
    $container.parent().find('.' + jsTooltipClass).hide();
}
exports.hideAll = function () {
	var tipEl = $('.' + jsTooltipClass);
	if(tipEl.length >0 && tipEl.is(":visible")) {
		tipEl.hide();
	}
}
exports.initShippingFeeCustomToolTipEvents = function (){
    $('#main').on('mouseenter', '.icon--Info', function (e) {
		if(window.innerWidth < 768) return;
        module.exports.show($(this), $(this).data('tooltip'),0,false);
    });
	
	$('#main').on('click', '.icon--Info', function (e) {
		e.stopImmediatePropagation();
		e.stopPropagation();
		if(window.innerWidth > 767) return;
		if($(this).parent().find('.js-tooltip').is(':visible')){
			module.exports.hide($(this));
		}else {
			module.exports.show($(this), $(this).data('tooltip'), 0, false);
		}
	});

    $('#main').on('mouseleave', '.icon--Info', function (e) {
        module.exports.hide($(this));
    });
}



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/product/tooltip.js